<template>
  <div class="basic-info">
    <TextField
      :id="'booking_start_date'"
    
      :type="'date'"
      :showEditIconOnHover="false"
      :showValidationIcons="true"
      :statusInside="true"
      :value="cdate.booking_start_date"
      :placeholder="$t('start_date')"
      @startEditing="e => startDateMenu = true"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    />

     <TextField 
        :id="'booking_end_date'"
       
        :type="'date'"
        :showEditIconOnHover="false"
        :showValidationIcons="true"
        :statusInside="true"
        :value="cdate.booking_end_date"
        :placeholder="$t('end_date')"
        @startEditing="e => endDateMenu = true"
        @validated="onValidation"
        @valuechanged="onTextfieldValueChangd"
      ></TextField>
    <!-- <v-menu
      :close-on-content-click="false"
      v-model="startDateMenu"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
    
     <TextField 
        slot="activator" 
        :id="'booking_start_date'"
        v-bind="textFieldConfig"
        :value="cdate.booking_start_date"
        :placeholder="$t('start_date')"
        @startEditing="e => startDateMenu = true"
        @validated="onValidation"
        @valuechanged="onTextfieldValueChangd"
      ></TextField> -->
      <!-- <v-date-picker 
        v-model="cdate.booking_start_date" 
        @input="startDateMenu = false"
      ></v-date-picker> -->
    <!-- </v-menu> --> 
    <!-- <v-menu
      :close-on-content-click="false"
      v-model="endDateMenu"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <TextField 
        slot="activator" 
        :id="'booking_end_date'"
        v-bind="textFieldConfig"
        :value="cdate.booking_end_date"
        :placeholder="$t('end_date')"
        @startEditing="e => endDateMenu = true"
        @validated="onValidation"
        @valuechanged="onTextfieldValueChangd"
      ></TextField>
      <v-date-picker 
        v-model="cdate.booking_end_date" 
        @input="endDateMenu = false"
      ></v-date-picker>
    </v-menu> -->
    <TextField
      :id="'venue_city'"
      v-bind="typeAheadTextFieldConfig"
      :placeholder="$t('city')"
      :value="cdate.venue_city"
      :options="cityList"
      @selected="onCitySelected"
      @valuechanged="onTextfieldValueChangd" 
      @validated="onValidation"   
    />
    <!-- <TextField  
      :id="'venue_city'"
      v-bind="textFieldConfig"
      :value="cdate.venue_city"
      required
      :placeholder="$t('city')"
      @valuechanged="onTextfieldValueChangd"
      @validated="onValidation"
    ></TextField> -->
    <Dropdown
      class="dt-dropdown"
      :options="countriesTV"
      :selected="countriesTV.find(e => e.value == cdate.venue_country)"
      box
      :placeholder="$t('country')"
      v-on:selectedChange="e => onDropdownChange('country', e)"
      :listHeight="95"
    ></Dropdown>
    <TextField  
      :id="'booking_date_name'"
      v-bind="textFieldConfig"
      :value="cdate.booking_date_name"
      :placeholder="$t('date_name')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <Dropdown
      class="dt-dropdown"
      :options="statusesTV"
      :selected="statusesTV.find(e => e.value === cdate.booking_status_id)"
      box
      :placeholder="$t('status')"
      v-on:selectedChange="e => onDropdownChange('selectedStatus', e)"
      :listHeight="95"
    ></Dropdown>
    <TextField
      :id="'booking_lineup'"
      v-bind="textAreaConfig"
      textarea
      :value="cdate.booking_lineup"
      :placeholder="$t('com_lineup')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField  
      :id="'booking_doors_open'"
      v-bind="textFieldConfig"
      :value="cdate.booking_doors_open"
      :placeholder="$t('opening_time')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField  
      :id="'booking_curfew'"
      v-bind="textFieldConfig"
      :value="cdate.booking_curfew"
      :placeholder="$t('curfew')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField 
      :id="'booking_lineup'"
      v-bind="textFieldConfig"
      :value="cdate.booking_lineup"
      :placeholder="$t('rs_crew_get_in')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    
    <template v-if="customFieldKeys.length>0">
      <TextField 
        v-for="(item, index) in customFieldKeys"
        :key="index"
        :id="'booking_cf_'+item['custom_field_id']"

        v-bind="textFieldConfig"
        :value="cdate[item['cfKey']]"
        :placeholder="$t(item['field_label'])"
        @validated="onValidation"
        @valuechanged="onTextfieldValueChangd"
    ></TextField>
    </template>
    

  </div>
</template>

<script>
import Dropdown from '@plugins/dropdown/dropdown';
import TextField from '@plugins/text-field/text-field';
import { EventHooks } from "../../../../plugins/text-field";
import { createCDate } from './cdate.model';
import { bookingRequestsService } from '../../services/booking-requests.service';
import { tv } from "../../../../models/text-value.model";
import {
  addRemoveSet,
  openWindow,
  downloadFile,
  subscribeSubject
} from "../../../../utility";
import { Subject } from "rxjs";
export default {
  components: {
    Dropdown,
    TextField
  },
  props: {
    cdate: {
      required: true,
      type: Object,
      default: () => createCDate({})
    },
    statuses: {
      required: true,
      type: Array,
      default: () => []
    },
    countries: {
      required: true,
      type: Array,
      default: () => []
    },
    customFieldKeys:{
      required: true,
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      startDateMenu: null,
      endDateMenu: null,
      
      validationResult: {},

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        statusInside: true,
      },
      textAreaConfig: {
        height: 132,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        statusInside: true,
      },
      typeAheadTextFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnKeyup,
        valueChangedEvent: EventHooks.OnKeyup,

        typeahead: true
      },
      citySubject:new Subject(),

      cities: [],
      
     // cityList:[]
    }
  },
  mounted:function(){
    subscribeSubject(this, this.citySubject, searchString => {
      if (searchString.length > 0) {
        this.fetchCities(searchString);
      }
    });

    //this.getCustomFieldKeys()
  
  },
  computed: {
    statusesTV: function() {
      return this.statuses.map(e => ({
        text: e.booking_status_name,
        value: e.booking_status_id
      }))
    },
    countriesTV: function() {
      return this.countries.map(e => ({
        text: e,
        value: e
      }))
    },
    cityList: function() {
      return (this.cities || []).map(tv("label", "label"));
    }
  },
  watch: {
  },
  
  methods: {
    
    onTextfieldValueChangd:async  function(name, value) {
      
      if(name=="venue_city"){
        this.citySubject.next(value)
        
      }
      this.$emit('changed', {name, value});
    },
    onValidation: function(id, validationResult) {
      // console.warn(id, validationResult);
      this.$set(this.validationResult, id, validationResult);
    },
    onDropdownChange: function(name, value) {
      if(name=="country"){
        this.cdate.venue_country=value.value
      }
      else if(name=="selectedStatus"){
        this.cdate.booking_status_id=value.value
      }
      console.log(name, value);
    },

    fetchCities: async function(search) {
      this.cities = await bookingRequestsService.getCityList(search).then(res => res.data);
      //console.log("RRRRRRR",cities)
      // this.cityList = (this.cities || []).map(
      //   tv("label", "city")
      // );
      // console.log("RRRRRRRRRR",this.cities, this.cityList, (this.cities || []).map(
      //   tv("label", "label")
      // ));
    },
    onCitySelected:function(selected){
      // console.log("RRRRRRRRRR",selected)
      const selectedCity = this.cities.find(e => e.label == selected.text);

      this.cdate.venue_city = selectedCity.city;
      this.cdate.venue_country = selectedCity.country;

      //console.log("RRRRR",this.cdate.venue_country)
      //this.cityList=[]
      //this.cdate
    }

  },

}
</script>


<style lang="scss" scoped>
  .dropdown.box {
    margin: 5px;
  }
</style>
